(function () {
  var EARTH_RADIUS_METERS = 6371008.8;

  function isValidCoordinate(latitude, longitude) {
    return Number.isFinite(latitude) && Number.isFinite(longitude)
      && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180;
  }

  function distanceMeters(fromLatitude, fromLongitude, toLatitude, toLongitude) {
    var toRadians = function (degrees) { return degrees * Math.PI / 180; };
    var latitudeDelta = toRadians(toLatitude - fromLatitude);
    var longitudeDelta = toRadians(toLongitude - fromLongitude);
    var a = Math.sin(latitudeDelta / 2) * Math.sin(latitudeDelta / 2)
      + Math.cos(toRadians(fromLatitude)) * Math.cos(toRadians(toLatitude)) * Math.sin(longitudeDelta / 2) * Math.sin(longitudeDelta / 2);
    return EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatDistance(value) {
    return value < 1000 ? '~' + Math.round(value) + ' m' : '~' + (value / 1000).toFixed(1) + ' km';
  }

  function renderDistance(element) {
    var cityLatitude = Number(element.dataset.cityLatitude);
    var cityLongitude = Number(element.dataset.cityLongitude);
    if (!isValidCoordinate(cityLatitude, cityLongitude)) return;
    var data = element.querySelector('[data-gen-location-warehouse-coordinates]');
    if (!data) return;
    var warehouses;
    try { warehouses = JSON.parse(data.textContent || '[]'); } catch (_) { return; }
    var nearest = null;
    warehouses.forEach(function (warehouse) {
      if (!isValidCoordinate(warehouse.latitude, warehouse.longitude)) return;
      var candidate = distanceMeters(cityLatitude, cityLongitude, warehouse.latitude, warehouse.longitude);
      if (nearest === null || candidate < nearest.distanceMeters) {
        nearest = {
          name: typeof warehouse.name === 'string' ? warehouse.name.trim() : '',
          address: typeof warehouse.address === 'string' ? warehouse.address.trim() : '',
          latitude: warehouse.latitude,
          longitude: warehouse.longitude,
          distanceMeters: candidate,
        };
      }
    });
    if (nearest === null) return;
    var map = element.querySelector('[data-gen-location-map-iframe]');
    if (map) {
      map.setAttribute('src', 'https://www.google.com/maps?q='
        + encodeURIComponent(nearest.latitude + ',' + nearest.longitude) + '&output=embed');
      if (element.dataset.cityName) map.setAttribute('title', 'Nearest warehouse to ' + element.dataset.cityName);
    }
    var heading = element.querySelector('[data-gen-location-map-heading]');
    if (heading && element.dataset.cityName) heading.textContent = 'Nearest warehouse to ' + element.dataset.cityName;
    var details = element.querySelector('[data-gen-location-warehouse-details]');
    var output = element.querySelector('[data-gen-location-warehouse-distance]');
    if (!output) return;
    output.textContent = 'Approximate straight-line distance: ' + formatDistance(nearest.distanceMeters);
    var warehouseLocation = element.querySelector('[data-gen-location-warehouse-location]');
    if (warehouseLocation && nearest.name && nearest.address) {
      warehouseLocation.textContent = 'Nearest warehouse: ' + nearest.name + ', ' + nearest.address;
      warehouseLocation.hidden = false;
    }
    if (details) details.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gen-location-map]').forEach(renderDistance);
  });
}());
